import { useEffect } from "react";
import { useState } from "react";
import Select from 'react-select';
import ApiService from "../../Core/Service/ApiService";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import AdminTable from "../../Components/AdminTable/AdminTable";
import { useNavigate } from "react-router-dom";

const TemplateList = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState();
    const [total, setTotal] = useState(0);
    const perPageOptions = [
        {value: 10, label: '10'},
        {value: 20, label: '20'},
        {value: 50, label: '50'},
        {value: 100, label: '100'},
    ]
    const [formData, setFormData] = useState({
        pageNum: 1,
        perPage: 10,
        search: {},
        sort: {}
    })
    const [loading, setLoading] = useState(false);
    const cmsContext = useContext(CmsContext);

    useEffect(() => {
        cmsContext.setBreadcrumb([
            {title: 'Template'},
            {title: 'List'},
        ]);
    }, []);

    const getRows = async () => {
        let response = await ApiService.get('/templates');
        setTotal(response.data.total);
        setRows(response.data.rows);
    }

    useEffect(() => {
        getRows();
    }, [formData])

    const onPageChanged = (pageNum) => {
        setFormData({
            ...formData,
            pageNum
        })
    }
    const onPerPageChanged = (opt) => {
        setFormData({
            ...formData,
            pageNum: 1,
            perPage: opt.value
        })
    }
    const handleSearch = (search) => {
        setFormData({
            ...formData,
            pageNum: 1,
            search: search
        })
    }
    const handleSort = (sort) => {
        setFormData({
            ...formData,
            pageNum: 1,
            sort: sort
        })
    }

    const onAddBtnClicked = () => {
        navigate(`/template/add`);
    }
    const gotoEdit = (row) => {
        navigate(`/template/edit/${row.id}`);
    }
    const handleCopy = (row) => {
        navigate(`/template/copy/${row.id}`);
    }
    const handleDelete = (row) => {
        if(window.confirm("Are you sure to delete?") == false) return;
        ApiService.delete(`/templates/${row.id}`).then(() => {
            getRows();
        })
    }

    const renderTbodyTr = (row, rowIndex) => {
        return (
            <tr key={rowIndex}>
                { columns.map((col, colIndex) => {
                    const el = renderTdCell(row, col.data ?? col.name, rowIndex, colIndex);
                    if(el) {
                        return <td key={colIndex}>{el}</td>
                    } else {
                        return <td key={colIndex}>{row[col.name]}</td>
                    }
                })}
            </tr>
        )
    }

    const renderTdCell = (row, colname, rowIndex, colIndex) => {
        switch(colname) {
            case 'action':
                return (
                <div className="d-flex justify-content-end">
                    <MDBBtn color="none" tag="a" onClick={() => gotoEdit(row)} title="Edit Content">
                        <MDBIcon fas icon="pencil-alt" size="lg" color="warning" />
                    </MDBBtn>
                    <MDBBtn color="none" tag="a" title="Copy Content" onClick={() => handleCopy(row)}>
                        <MDBIcon far icon='copy' size="lg" className="ms-2" color="warning" />
                    </MDBBtn>
                    <MDBBtn color="none" tag="a" onClick={()=>handleDelete(row)} title="Delete Content">
                        <MDBIcon far icon="trash-alt" size="lg" color="danger" className="ms-2" />
                    </MDBBtn>
                </div>
                )
            case 'background':
                const bg = JSON.parse(row[colname] ?? '');
                return (
                <span>
                    <label className="me-1">Background Color: </label>
                    <span className="px-3 py-1" style={{backgroundColor: bg.bg_color}}>&nbsp;</span>
                </span>
                )
                
        }
    };

    const columns = [
        {name: 'internal_name', title: 'Internal Name', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'background', title: 'Background'},
        {name: 'action', title: 'Action'},
    ];

    return (
    <div className="template-list p-4">
        <div className="d-flex align-items-center me-1 mt-2">
            <div className="flex-fluid d-flex align-items-center ps-2">
                <label>Per Page:</label>
                <div className="ms-2" style={{width:100}}>
                    <Select 
                        options={perPageOptions} 
                        value={perPageOptions.find(opt=>opt.value == formData.perPage)} 
                        onChange={onPerPageChanged}
                    />
                </div>
                <label className="ms-4">
                    Found 
                    <span className='fw-bold mx-2' style={{color: '#333'}}>{total}</span> 
                    Matching Results.
                </label>
            </div>
            <div className="">
                <MDBBtn className="ms-4" onClick={onAddBtnClicked}>
                    <MDBIcon icon="plus" />
                    <span className="ms-1">Create New Template</span>
                </MDBBtn>
            </div>
        </div>

        <div className="mt-2">
            <AdminTable
                columns={columns} 
                rows={rows} 
                renderTbodyTr={renderTbodyTr} 
                handleSearch={handleSearch} 
                handleSort={handleSort}
                search={formData.search} 
                sort={formData.sort}
            />
        </div>
    </div>
    )
}

export default TemplateList;